<template>
  <div class="authorcard" :style="getBackground()">
    <div class="authorcard__content">
      <h5 class="authorcard__label">Publié par:</h5>
      <div class="authorcard__author">
        {{ author.name }}
      </div>
      <router-link
        class="btn--alt authorcard__btn"
        :to="{ name: 'author', params: { slug: author.slug } }"
      >
        <span>Les recettes de {{ author.name }} </span>
        <svgicon icon="chevron-right"></svgicon>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "Author",
  props: {
    author: { type: Object }
  },
  methods: {
    getBackground() {
      return { backgroundImage: `url(${this.author.background})` };
    }
  }
};
</script>
<style lang="scss" scoped>
.authorcard {
  text-align: left;
  padding: 20px 30px;
  background-size: cover;
  position: relative;
  text-shadow: 1px 1px 2px rgba($white, 0.9);
  &::before {
    content: $pseudo-content;
    @include absolute(0, 0, 0, 0);
    background: linear-gradient(
      90deg,
      rgba($white, 0.9) 30%,
      rgba($white, 0.2) 100%
    );
  }
  &__content {
    position: relative;
  }
  &__label {
    font-size: 14px;
    text-transform: uppercase;
  }
  &__author {
    @include font-bigtitle();
    font-size: 1.6em;
    margin-bottom: 10px;
  }
}
</style>
